import React from "react";
import BookingDetails from "./BookingDetails/BookingDetails";
import { BookingSummary } from "./BookingSummary";

export const Hull = () => {
  return (
    <>
      <BookingSummary premiumType="HULL" />
      <BookingDetails premiumType="HULL" />
    </>
  );
};
